import {} from "../node/index.js";
import {} from "./Net.js";
import { findNodeEntry } from "./findNodeEntry.js";
export function findPortRecord(net, node) {
    const nodeEntry = findNodeEntry(net, node);
    return nodeEntry === null || nodeEntry === void 0 ? void 0 : nodeEntry.ports;
}
//# sourceMappingURL=findPortRecord.js.map